import http from "@/services/http";

export const combos = () => {
  async function list() {
    const {data} = await http.get('/combos/list');
    return data;
  }

  async function getOne(id) {
    const {data} = await http.get('/combos/getOne/'+id);
    return data;
  }

  async function store(combo) {
    const response = await http.post('/combos/store', combo);
    return response.data;
  }

  async function update(combo) {
    const response = await http.post('/combos/edit', combo);
    return response.data;
  }

  async function delet(id) {
    await http.put('/combos/delete/'+id, {});
    return true;
  }

  return {list, getOne, store, update, delet};
}
